<!--
 * @Description: App版本发布管理页面
 * @Author: laoliu
 * @Date: 2022-08-04 11:43:52
-->
<template>
  <app-version />
</template>

<script>
export default {
  mounted() {
      this.$emit("breadcrumb", {text1: '系统管理', text2: 'APP发布'});
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sysmng/AppRelease.vue